import { useState } from "react";
import { faqs } from "../../../mocks/articles";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto max-w-5xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center">
          <p className="section-kicker text-xs font-semibold text-accent-700">常见问题 FAQ</p>
          <h2 className="mt-2 font-serif text-2xl font-black text-foreground-950 md:text-3xl">关于今日瓜报，你想知道的</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            关于内容立场、栏目设置、订阅方式与信源处理等，这里一次性说清楚。
          </p>
        </div>

        <div className="mt-9 space-y-3">
          {faqs.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={idx}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  isOpen ? "border-accent-300 bg-background-50" : "border-background-200 bg-background-50/60"
                }`}
              >
                <h3>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    className="flex w-full items-center gap-3 px-5 py-4 text-left md:px-6"
                    aria-expanded={isOpen}
                  >
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm ${isOpen ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"}`}>
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                    </span>
                    <span className="flex-1 font-serif text-base font-bold text-foreground-950 md:text-lg">{f.q}</span>
                  </button>
                </h3>
                <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-15 text-sm leading-7 text-foreground-700 md:px-6 md:pl-16">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}